<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                      <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                       &nbsp;&nbsp;&nbsp;
                      <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("companyFulfillmentOmsAccessAdd") }}</h6>
                      <button
                        class="btn btn-default btn-sm float-end"
                        @click="resetForm"
                        type="button"
                      >
                      <i class="link-icon" data-feather="repeat"></i>
                        {{ $t("resetFormTxt") }}
                      </button>
                </div>
                <div class="card-body">
      

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                     
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('company_code')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                       
                         <v-select
                          :options="fetchCompany"
                          v-model="dropdownCompany"
                          label="code"
                          return-object
                          @search="asyncSearchCompany"
                        ></v-select>

                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('fulfillment_code')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                         <v-select
                          :options="fetchFulfillment"
                          v-model="dropdownFulfillment"
                          label="code"
                          return-object
                          @search="asyncSearchFulfillment"
                        ></v-select>

                        <div v-if="errors.fulfillment_center_id">
                          <div
                            v-for="error in errors.fulfillment_center_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

 
                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div> <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CompanyFulfillmentOmsAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchSystemCode:[],
      fetchCompany:[],
      fetchFulfillment:[],
      company_type:"",
      dropdownCompany:{},
      dropdownFulfillment:{},
      userData: "",
      userRole: "",
      companyCode: "",
      forms: { customer_id: "", fulfillment_center_id: "" },
    };
  },
  watch: {},
  methods: { 
 
    asyncSearchCompany(ev){
      const baseURI = this.$settings.endPointFluxOms + "v2/customer/index?code="+ev;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchCompany=response.data.datas.data;
        }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
          this.error(this.$t("check_internet_connection_txt"));
          
        }else{

          if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }

        }
      });
    },
 
    asyncSearchFulfillment(ev){
      const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/index?code="+ev;
     
      return this.$http
        .get(
          baseURI,{ timeout: 10000 }
        )
        .then((response) => {
           this.fetchFulfillment=response.data.datas.data;
        }).catch((error) => {
        this.loading();
        
        if(error.code == "ECONNABORTED"){
          this.error(this.$t("check_internet_connection_txt"));
          
        }else{

          if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }

        }
      });
    },

    resetForm() {
      this.forms.customer_id = "";
      this.forms.fulfillment_center_id = "";


    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      this.userRole       = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'CompanyFulfillmentOMSController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_create){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    backForm() {
       window.location.href = "/company-fulfillment-oms";
    },


    submitData() {
      
      this.isLoading = true;
    
      this.forms.customer_id            = this.dropdownCompany.customer_id;
      this.forms.fulfillment_center_id  = this.dropdownFulfillment.fulfillment_center_id;
      
      const baseURI  =  this.$settings.endPointFluxOms+"v2/customer-fulfillment/store";
      this.$http.post(baseURI,this.forms,{ timeout: 10000 }).then((response) => {
          this.loading();
          if(response.data.status === 200) {
          //this.resetForm();
              this.isLoading = false;
              this.errors = [];
              //console.log(response.data.datas.user_id);
              var params = this.$onRandom(response.data.datas.customer_fulfillment_id);
                window.location.href = "/company-fulfillment-oms/detail/" + params + "?status=200&msg=Successfully";
              // this.success('Berhasil');
          }else{
              this.isLoading = false;
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
          }
      }).catch(error => {
            this.loading();
            this.isLoading = false;
            if(error.code == "ECONNABORTED"){
              this.error("Please Check Your Internet Connection");
            }

        if (error.response) {
            if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
            }else if (error.response.status === 401) {
                this.logout();
            } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
            }else if (error.response.status === 500) {
                this.$router.push('/server-error');
            }else{
                this.$router.push('/page-not-found');
            }
          }
          //this.resetForm();
      });

    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },
    logout(){

        const baseURI = this.$settings.endPoint + "user/logout";
        this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
            
        console.log(response);

        });

        this.$logoutUser();
        window.location.href = '/';
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
  },
};
</script>
<style scoped>
.blur-content{
  filter: blur(5px); 
}
</style>